var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25",
    "data-name": "Group 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44.2 44.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 44.2,
    height: 44.169,
    fill: "#e2bd69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M34.018,44.17a16.63,16.63,0,0,1-6.05-1.2A41.016,41.016,0,0,1,19.5,39.184a50.956,50.956,0,0,1-9.313-7.96A37.459,37.459,0,0,1,3.845,22.66,44.324,44.324,0,0,1,.314,13.2,11.326,11.326,0,0,1,1.658,4.75c.142-.255.308-.5.439-.759C3.578,1.026,6.248.2,9.267,0a1.326,1.326,0,0,1,1.3.65c.259.419.522.836.769,1.261,1.394,2.4,2.766,4.809,4.181,7.194.8,1.339.811,1.947-.3,3.054-.892.886-1.9,1.658-2.846,2.485-.358.312-.718.625-1.055.959-1.052,1.043-1.142,1.57-.417,2.853.656,1.16,1.332,2.31,2.045,3.436A30.533,30.533,0,0,0,23.877,32.208c.824.467,1.652.93,2.492,1.368a1.4,1.4,0,0,0,1.8-.325c.934-1.024,1.816-2.1,2.744-3.128.476-.528.987-1.027,1.511-1.509a1.714,1.714,0,0,1,2.216-.194c1.932,1.142,3.86,2.289,5.8,3.419.82.478,1.644.954,2.5,1.366a2,2,0,0,1,1.2,2.465,29.71,29.71,0,0,1-.811,3.229,3.853,3.853,0,0,1-.994,1.542,13.14,13.14,0,0,1-8.306,3.729",
    transform: "translate(0 0)",
    fill: "#e2bd69"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.70c50d59e64b51517b6fbb58a109dc32.svg";
export { ForwardRef as ReactComponent };